export class Airline {
	id: number;
	iata: string;
	icao: string;
	name: string[];
}
